'use client';

import { ApolloNextAppProvider } from '@apollo/client-integration-nextjs';

import { ApolloClient } from './apollo-client';

export function ApolloWrapper({ children }: React.PropsWithChildren) {
  return (
    <ApolloNextAppProvider makeClient={() => ApolloClient}>
      {children}
    </ApolloNextAppProvider>
  );
}
